import { useEffect, useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { ThemeToggle } from '@opus/ui-components';
import { useNavigation } from '@/lib/useNavigation';

/** Fixed navbar: scroll shadow, api-driven links (static fallback), mobile drawer (brief 003-001-001 §4). */
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { data: links } = useNavigation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const nav = links ?? [];

  return (
    <header className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-4">
        <Link to="/" className="flex items-center gap-2" aria-label="opuschamber — home">
          <img src="/images/opuschamber.svg" alt="" width={32} height={32} className="h-8 w-auto" />
          <span className="ml-2 text-xl font-bold font-mono">opuschamber</span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="main">
          {nav.map((node) => (
            <NavLink
              key={node.id}
              to={node.path ?? '/'}
              className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
              end={node.path === '/'}
            >
              {node.label}
            </NavLink>
          ))}
          <ThemeToggle />
        </nav>

        <button
          className="md:hidden"
          aria-label={open ? 'close menu' : 'open menu'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? '✕' : '☰'}
        </button>
      </div>

      {open && (
        <div className="mobile-menu border-t border-border bg-background md:hidden">
          <nav className="flex flex-col px-4 py-3" aria-label="mobile">
            {nav.map((node) => (
              <NavLink
                key={node.id}
                to={node.path ?? '/'}
                className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
                end={node.path === '/'}
                onClick={() => setOpen(false)}
              >
                {node.label}
              </NavLink>
            ))}
            <div className="mt-2 flex justify-end">
              <ThemeToggle />
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
